/*@ngInject*/
const RateStatusRowDomManagerDirective = function ($rootScope, $timeout, $document, configurationConstant) {

    let linkFunction = function ($scope, $elm, $attr) {

        function handleClick(event) {

            if (event.target.className === 'match') {
                event.preventDefault();
                return;
            } else if (isClassNameExist(event, 'rowComponentInner')) {
                $scope.$apply(function () {
                    $rootScope.$broadcast(configurationConstant.event.STATE_RATE_ROW_CLICKED, $scope.$ctrl.item.id);
                    $scope.$ctrl.setDefaultState();
                });
                event.preventDefault();
            } else if (isClassNameExist(event, 'locationLabelBox') || isClassNameExist(event, 'locationLabel') ||
                isClassNameExist(event, 'productLabelBox') || isClassNameExist(event, 'productLabel') ||
                isClassNameExist(event, 'statusLabelBox') || isClassNameExist(event, 'statusLabel') ||
                isClassNameExist(event, 'match') ||
                isClassNameExist(event, 'dateEffectiveLabelBox') || isClassNameExist(event, 'dateEffectiveLabel') ||
                isClassNameExist(event, 'dateExpirationLabelBox') || isClassNameExist(event, 'dateExpirationLabel')) {
                $scope.$apply(function () {
                    $rootScope.$broadcast(configurationConstant.event.STATE_RATE_ROW_CLICKED, $scope.$ctrl.item.id);
                    $scope.$ctrl.changeState();
                });
                event.preventDefault();

                $timeout(() => {
                    let clickTarget;
                    if(isClassNameExist(event, 'locationLabel')) {
                        clickTarget = $('.location .match');
                    }

                    if(isClassNameExist(event, 'productLabel')) {
                        clickTarget = $('.product .match');
                    }

                    if(isClassNameExist(event, 'statusLabel')) {
                        clickTarget = $('.status .match');
                    }

                    if(isClassNameExist(event, 'dateEffectiveLabel')){
                        clickTarget = $('.dateEffectiveBox .toggleCalendarPopup');
                    }

                    if(isClassNameExist(event, 'dateExpirationLabel')){
                        clickTarget = $('.dateExpirationBox .toggleCalendarPopup');
                    }
                    clickTarget[0].click();
                }, 0);

            }
            event.stopPropagation();
        }

        $scope.$on(configurationConstant.event.STATE_RATE_ROW_CLICKED, function (event, item) {
            if ($scope.$ctrl.item.id !== item) {
                $scope.$ctrl.rowSelected = false;
            }
        });

        function isClassNameExist(event, className) {
            return event.target.className.indexOf(className) !== -1
        }

        function onDocumentClick(event) {

            let isHeader = $(event.target).closest('.headerContent').length > 0,
            isGridHeader = $(event.target).closest('.columnHeader').length > 0,
            isAppHeader = $(event.target).closest('.appHeader').length > 0,
            isRateStatusManager = $(event.target).closest('.rateStatusManager').length > 0,
            isElement = isHeader || isGridHeader || isAppHeader;
            if (isElement) {
                $scope.$apply(function () {
                    $scope.$ctrl.setDefaultState();
                });
                event.preventDefault();
            }
        }

        if(!$scope.$ctrl.isReadOnly) {
            $elm.bind('click', handleClick);
            $document.bind('click', onDocumentClick);
        }
        $scope.$on('$destroy', function () {
            $elm.unbind('click', handleClick);
            $document.unbind('click', onDocumentClick);
        });

    };

    return {
        link: linkFunction,
        restrict: 'A'
    };
};

angular.module('ums.configuration')
    .directive('umRateStatusRowDomManager', RateStatusRowDomManagerDirective);



